import * as React from "react";
import { BooleanField, Datagrid, ExportButton, List, TextField, TopToolbar } from "react-admin";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { CustomDateField } from "../../../Components/CustomDateField";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const CockpitRejectionRateViewList = props => {
  const ListActions = props => (
    <TopToolbar>
      <ExportButton {...props} maxResults={9999} />
    </TopToolbar>
  );

  const exporter = records => {
    const data = records.map(record => ({
      RefNo: record.refNo,
      Customer: record.customer,
      "Svc Pn": record.svcPn,
      "Svc Sn": record.svcSn,
      "Request Date": record.createdDate,
      "Forward Date To Carrier": record.forwardDateToCarrier,
      "Reject Reason": record.rejectReasons,
      "Svc Rejection Note": record.svcRejectionNote,
      "Rejection Order": record.isRejectionOrder,
      "Tt Reject Note": record.ttRejectionNote,
    }));

    const columns = Object.keys(data[0]).map(record => ({ header: record }));

    ExcelExport(columns, data, "Rejection Rate List");
  };

  return (
    <PoolList
      {...props}
      filterDefaultValues={props.filterParams}
      actions={<ListActions />}
      exporter={exporter}
      bulkActionButtons={false}
      filter={{ isRejected: true }}
    >
      <Datagrid>
        <TextField source="refNo" />
        <TextField source="customer" />
        <TextField source="svcPn" />
        <TextField source="svcSn" />
        <CustomDateField source="createdDate" label="Request date" showTime />
        <CustomDateField source="forwardDateToCarrier" showTime />
        <TextField source="svcRejectionNote" sortable={false} />
        <TextField source="ttRejectionNote" sortable={false} />
        <TextField source="rejectReasons" sortable={false} />
        <BooleanField source="isRejectionOrder" />
      </Datagrid>
    </PoolList>
  );
};

export default CockpitRejectionRateViewList;
